import { render } from "./CardsPlansComponent.vue?vue&type=template&id=81a378ba"
import script from "./CardsPlansComponent.vue?vue&type=script&lang=js"
export * from "./CardsPlansComponent.vue?vue&type=script&lang=js"

import "./CardsPlansComponent.vue?vue&type=style&index=0&id=81a378ba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__